import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import anime from 'animejs/lib/anime.es.js';
import { AvatarComponent } from 'app/components/ui-kit/images/avatar/avatar.component';

import { SvgLoaderComponent } from 'app/components/ui-kit/images/svg-loader/svg-loader.component';

@Component({
  selector: 'app-user-typing',
  standalone: true,
  imports: [SvgLoaderComponent, CommonModule],
  templateUrl: './user-typing.component.html',
  styleUrl: './user-typing.component.scss'
})
export class UserTypingComponent {
  @ViewChild('bubblesContainer', { static: true }) bubblesContainer!: ElementRef;
  @Input() imgURL: string = null;
  private animationCycle = 0;
  private readonly MAX_CYCLES = 10;

  ngAfterViewInit() {
    const bubbles: NodeListOf<HTMLElement> = this.bubblesContainer.nativeElement.querySelectorAll('.bubble');

    const runAnimationCycle = () => {
      bubbles.forEach((bubble, index) => {
        anime({
          targets: bubble,
          translateY: [
            { value: -2, duration: 300 },
            { value: 2, duration: 300 },
          ],
          opacity: [
            { value: 0.8, duration: 300 },
            { value: 0.5, duration: 300 },
          ],
          delay: (index % 3) * 180,
          easing: 'easeInOutSine',
          direction: 'alternate',
          duration: 600,
          complete: () => {
            if (index === bubbles.length - 1) {
              this.animationCycle++;
              if (this.animationCycle >= this.MAX_CYCLES) {
                anime.remove(bubbles);
                this.animationCycle = 0;
              }
              runAnimationCycle();
            }
          },
        });
      });
    };

    runAnimationCycle();
  }

  ngOnDestroy(): void {
    anime.remove(this.bubblesContainer.nativeElement.querySelectorAll('.bubble'));
  }
}
